export default "__VITE_ASSET__257552d9__"